import React, {useState} from 'react';
import {MessageDialog} from '../MessageDialog/MessageDialog';
import {useTranslation} from 'react-i18next';
import {ErrorMessageProps} from './ErrorsType';
import {HttpError} from '../../../../api/client';
import {ApiError} from './ErrorBoundary';
import {useStyleSpanUnderline} from './InternalServerErrorMessage';


function getDefaultMessage(error: string | Error): { message: string; errorId: string; } {
  try {
    if ((error as HttpError)?.data) {
      if (typeof (error as HttpError)?.data === 'string')
        return {message: (error as HttpError)?.data, errorId: (error as HttpError).traceId ?? ''};
      const apiError = (error as HttpError).data as ApiError;
      if (apiError.message)
        return {message: apiError.message, errorId: apiError.referanseId};
    }
    if ((error as Error)?.message) {
      let message = (error as Error)?.message;
      const errorId = (error as Error).stack ?? '';
      if(message === 'null')
        message = 'Null Exception';
      return {message: message, errorId: errorId};
    }
    if (typeof error === 'string')
      return {message: error, errorId: ''};
    throw error;
  } catch (e: any) {
    return {message: e.message, errorId: e.stack};
  }
}


export const DefaultErrorMessage: React.FC<ErrorMessageProps> = ({open, onClose, error}) => {
  const {message, errorId} = getDefaultMessage(error);
  const [showDetail, setShowDetail] = useState(false);
  const {t} = useTranslation();
  const {underlineHover} = useStyleSpanUnderline();
  return (
    <MessageDialog title={'En feil har oppstått'} width={700} height={300} open={open} onClose={onClose}>
      <div>
        <span>{t(message ?? '')}</span><span onClick={() => setShowDetail(prev => !prev)} className={underlineHover}> Les mer.</span>
        <br/>
        {
          errorId?.length > 0 && showDetail &&
          (
            <span style={{whiteSpace: 'pre-wrap', display: 'block',width: 'max-content'}} title={t('TraceId-Description')}>
                  {t('ReferanseId')}: {errorId ?? ''}
              <br/>
            </span>)
        }
      </div>
    </MessageDialog>
  );
};
